import Customer from "./customer.model";
import Vehicle from "./vehicle.model";
import Service from "./service.model";
import Tyre from "./tyre.model";
import Rim from "./rim.model";

export default class WheelStorage {

    constructor(data) {
        this.id = null;
        this.number = null;
        this.location = null;
        this.type = null;
        this.active = false;
        this.state = null;
        this.status = null;
        this.storageDate = null;
        this.swapDate = null;
        this.endDate = null;
        this.isOverdue = null;
        this.note = null;
        this.hubcapCount = null;
        this.rimlockCount = null;
        this.wheelNutCount = null;
        this.worstProfileDepth = null;
        this.worstTyreAge = null;
        this.rimType = null;

        this.customer = null;
        this.vehicle = null;
        this.services = [];

        this.wheel = {
            front: {
                left: {tyre: null, rim: null},
                right: {tyre: null, rim: null}
            },
            rear: {
                left: {tyre: null, rim: null},
                right: {tyre: null, rim: null}
            }
        };

        if (data) {
            Object.assign(this, data);

            if (this.customer) {
                this.customer = new Customer(this.customer);
            }

            if (this.vehicle) {
                this.vehicle = new Vehicle(this.vehicle);
            }

            this.initWheel('front');
            this.initWheel('rear');

            if (this.services) {
                this.services = this.services.map((serviceData)=> {
                    return new Service(serviceData);
                });
            }
        }
    }

    initWheel(type) {
        if (this.wheel[type] && this.wheel[type].left) {
            if (this.wheel[type].left.tyre) {
                this.wheel[type].left.tyre = new Tyre(this.wheel[type].left.tyre);
            }

            if (this.wheel[type].left.rim) {
                this.wheel[type].left.rim = new Rim(this.wheel[type].left.rim);
            }

            if (this.wheel[type].right.tyre) {
                this.wheel[type].right.tyre = new Tyre(this.wheel[type].right.tyre);
            }

            if (this.wheel[type].right.rim) {
                this.wheel[type].right.rim = new Rim(this.wheel[type].right.rim);
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/modules/main/model/wheelstorage.model.js